import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { AlertTriangle, Trash2, X } from 'lucide-react';

interface DeleteChannelModalProps {
  channel: { id: string; name: string; type: string };
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

const DeleteChannelModal: React.FC<DeleteChannelModalProps> = ({ channel, onConfirm, onClose }) => {
  const [loading, setLoading] = useState(false);
  const isCategory = channel.type === 'category';

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-md rounded-2xl border border-error/30 bg-bg-secondary shadow-2xl shadow-black/50" onClick={(event) => event.stopPropagation()}>
        <header className="flex items-center justify-between border-b border-border-color px-5 py-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-error/15 text-error">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <div>
              <h2 className="text-base font-bold text-text-primary">Delete {isCategory ? 'Category' : 'Channel'}</h2>
              <p className="text-xs text-text-muted">This action cannot be undone.</p>
            </div>
          </div>
          <button onClick={onClose} className="rounded-lg p-2 text-text-muted hover:bg-highlight hover:text-text-primary">
            <X className="h-4 w-4" />
          </button>
        </header>
        <main className="space-y-4 p-5">
          <p className="text-sm text-text-secondary">
            Are you sure you want to delete <span className="font-bold text-text-primary">{channel.name}</span>?
            {isCategory ? ' Channels inside this category will be moved out of it.' : ' Messages in this channel will no longer be accessible.'}
          </p>
          <div className="flex justify-end gap-3">
            <button className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
            <button
              className="inline-flex items-center gap-2 rounded-lg bg-error px-4 py-2 text-sm font-bold text-white disabled:opacity-60"
              disabled={loading}
              onClick={async () => {
                setLoading(true);
                try {
                  await onConfirm();
                  onClose();
                } finally {
                  setLoading(false);
                }
              }}
            >
              <Trash2 className="h-4 w-4" />
              Delete
            </button>
          </div>
        </main>
      </div>
    </div>,
    document.body,
  );
};

export default DeleteChannelModal;
